<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                    <div>
                        <AmountSelectorListTeachMoms/>
                    </div>
                <FormSection title="3. Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>   
                </FormSection>
                <FormSection title="" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="4. Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Pay now"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    if (props.campaign) {
      setValue('applications.0.campaign', props.campaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">
.form-container.ou-donation-form{
     margin: 0px;
    padding: 0px;
    box-shadow: none; 
    max-width: 100%;
}
h2{
    font-weight: 600;
    margin-bottom: 20px;
    margin-top: 0px;
    font-size: 20px;
    color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
      min-width: 49% !important;
    max-width: 49% !important;
    @media (min-width: 720px) {
    min-width: 125px !important;
    max-width: 125px !important;
    }
}
::v-deep .amount_other__wrapper{
        min-width: 49% !important;
    max-width: 49% !important;
    @media (min-width: 720px) {
    min-width: 200px !important;
    max-width: 200px !important;
    }
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: flex-start;
  label {
    font-weight: 500;
    background: #0c3450 !important;
    color: white !important;
    display: block !important;
  }
  input[type='radio']:checked + label {
    background: #BE9E5F !important;
}
.label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 17px;
    font-style: italic;
    padding-top: 0;
    color: white !important
}
 .label-amount {
  background: none !important;
  display: block !important;
  height: auto !important;
  max-width: 100%;
  min-width: 100% !important;
  border: none !important;
  font-size: 18px;
  text-align: center;
}
.amount_other__wrapper::before {
    background: #0c3450 !important;
    color: white !important;
    font-weight: bold;
}
}
</style>

